'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { IconKey } from '@nx-frontend/shared/types/icon';

interface IconSelectorProps {
  onIconSelect: (value: string) => void;
}

export function IconSelector({ onIconSelect, ...props }: IconSelectorProps) {
  const t = useTranslations('shared');
  const iconKeys = Object.keys(IconsMap);
  const [iconList, setIconList] = useState(iconKeys);

  const searchIcons = (value: string) => {
    const founded = iconKeys.filter((icon) =>
      icon.toLocaleLowerCase().replace('_', ' ').includes(value.toLocaleLowerCase())
    );
    setIconList(founded);
  };

  return (
    <div className="icon-selector">
      <div className="flex flex-col gap-2 p-2 h-[50vh] overflow-auto">
        <div className="w-full h-8 relative">
          <input
            aria-label="Type to search for an icon"
            className="pl-8 w-full bg-neutral-100 h-8 rounded"
            placeholder={t('image-selector.search_icon')}
            type="text"
            onChange={(e) => {
              searchIcons(e.currentTarget.value);
            }}
          />
          <Icon icon={IconsMap.SEARCH} className="w-5 h-5 text-neutral-500 absolute top-[0.4rem] left-[0.4rem]" />
        </div>
        <div className="grid gap-0 grid-cols-[repeat(auto-fill,2.25rem)] justify-between mx-2 my-0">
          {iconList.map((iconKey) => (
            <div
              key={iconKey}
              data-key={iconKey}
              onClick={() => {
                onIconSelect(iconKey);
              }}
              className=" hover:bg-cyan-100 rounded p-1 cursor-pointer w-8 h-8"
            >
              <Icon icon={IconsMap[iconKey as IconKey]} className="text-neutral-600 w-full h-full" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
